module.exports = __webpack_public_path__ + "static/media/footer.3fc8e97e.svg";